import React, { Component } from 'react';
import RecommendedMode from './recommended_mode';
import ManualMode from './manual_mode';

class ReconciliationMode extends Component {
    constructor(props) {
        super(props)

        this.state = {
            reconcile_mode: 'Recommended',// supports Manual or Recommended or tabular
        }
    }

    // mode means BATCH OR RECONCILE
    // currentMode means Recommended or Manual

    render() {
        const { reconcile_mode } = this.state;
        return (
            reconcile_mode === 'Recommended' ?
                <RecommendedMode
                    onToggle={() => {
                        this.setState({
                            reconcile_mode: reconcile_mode === 'Recommended' ? 'Manual' : 'Recommended'
                        })
                    }}
                    currentMode={reconcile_mode}
                    reconciler_id={this.props.reconciler_id} 
                    source_id={this.props.source_id}
                    key={`${this.props.reconciler_id}Recommended`} 
                    reconciler={this.props.reconciler} 
                    mode={this.props.mode}
                    onModeChange={this.props.onModeChange}
                    />
                : <ManualMode
                    onToggle={() => {
                        this.setState({
                            reconcile_mode: reconcile_mode === 'Recommended' ? 'Manual' : 'Recommended'
                        })
                    }}
                    currentMode={reconcile_mode}

                    mode={this.props.mode}
                    onModeChange={this.props.onModeChange}

                    reconciler_id={this.props.reconciler_id} 
                    source_id={this.props.source_id}
                    key={`${this.props.reconciler_id}Manual`} 
                    reconciler={this.props.reconciler} />
        );
    }
}

export default ReconciliationMode;
